<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import SidebarLayout from '@/layout/SidebarLayout.vue';
import SecurityTrim from '@/components/ui/SecurityTrim.vue';
import IdSearchHeader from '@/components/ui/IdSearchHeader.vue';
import FundingSourceTable from '@/components/funding-sources/FundingSourceTable.vue';
import { useFundingSourceSearches } from '@/components/funding-sources/fundingSourceSearches';
import { AccountActions, FundingSourceActions } from '@/integrations/Immersve/auth/actions';

const route = useRoute();
const searches = useFundingSourceSearches();
const selected = ref<string>();

const accountId = computed(() =>
  typeof route.query.account === 'string' ? route.query.account : ''
);
</script>

<template>
  <SidebarLayout>
    <!-- Listing funding sources is an account read: amethyst checks
    account:read on the account in the path. A user who can only read funding
    sources is let in too, to search by funding source ID instead. Each is
    asked for on any account, as there is none to ask about until one is
    searched. -->
    <SecurityTrim
      :actions="[AccountActions.Read, FundingSourceActions.Read]"
      account-id="*"
      match="any"
    >
      <div class="px-4 py-6 md:px-8" data-test="screen-funding-sources">
        <IdSearchHeader v-model:selected="selected" :searches="searches" />
        <template v-if="selected === 'account'">
          <FundingSourceTable v-if="accountId" :account-id="accountId" />
          <p v-else class="text-sm text-gray-500" data-test="funding-sources-prompt">
            Enter an account ID to list its funding sources.
          </p>
        </template>
        <p v-else class="text-sm text-gray-500" data-test="funding-source-prompt">
          Enter a funding source ID to see its details.
        </p>
      </div>
    </SecurityTrim>
  </SidebarLayout>
</template>
